<div class="container">
  @if(error) {
    <div class="alert alert-danger">{{ error }}</div>
  }
  <h1>
    @switch(editing) {
      @case(true) {
        <div class="alert alert-info">
          Modifying a RID that belongs to a Metadata Report will cause the Metadata Report to be re-registered and any existing Registered Reports for the Metadata Report will be cancelled.
        </div>
        <span>Edit Rid {{rid.id}}</span>
      }
      @case(false) {
        <span>Register a new RID</span>
      }
    }
  </h1>
  <form name="ridForm" class="form-horizontal">
    <div class="row">
      <div class="form-group">
        <label for="ridId">RID id:</label>
        <input id="ridId" class="form-control" name="id" type="text" [formControl]="ridForm.controls.id" required>
      </div>
      <div class="form-group">
        <label for="ridExternalId">External ID:</label>
        <input id="ridExternalId" class="form-control" name="external_id" type="text" [formControl]="ridForm.controls.external_id">
      </div>

      <!-- Add MRID field -->
      <div class="form-group">
        <label for="ridMrid">MRID (Optional):</label>
        <input id="ridMrid" class="form-control" name="mrid" type="text" [formControl]="ridForm.controls.mrid">
      </div>

      @if(rid.data_source == 'x-energy') {
        <div class="form-group">
          <label for="channelInput">Channel id:</label>
          @switch(editing) {
            @case(true) {
              <input name="channelId" id="channelInput" class="form-control" type="text" [formControl]="ridForm.controls.channel" required="rid.data_source == 'x-energy'">
            }
            @case(false) {
              <select name="channelId" id="channelSelect" class="form-control" type="text" (change)="changeChannels($event.target)" required="rid.data_source == 'x-energy'">
                <option disabled selected value></option>
                @for(channel of channels; track channel) {
                  <option [value]="channel.id">{{channel.display_label}} ({{channel.id}} - {{channel.siScaleCode}}{{channel.itemUnit}})</option>
                }
              </select>
            }
          }
        </div>
      }
      @if(rid.data_source == 'basic') {
        <div class="form-group">
          <label for="aggregationTypeInput">Aggregation type:</label>
          @if(editing) {
            <input name="aggregationType" id="aggregationTypeInput" class="form-control" type="text" [formControl]="ridForm.controls.aggregationType">
          }
          @if(!editing) {
            <select name="aggregationType" id="aggregationTypeSelect" class="form-control" type="text" required="rid.data_source == 'basic'" (change)="changeAggType($event.target)">
              <option disabled selected value></option>
              @for(agg_type of aggregation_types; track agg_type) {
                <option [value]="agg_type">{{agg_type}}</option>
              }
            </select>
          }
        </div>
      }
      <div class="form-group">
        <label for="dataSource">Data source:</label>
        @if(editing) {
          <input name="dataSource" id="dataSource" class="form-control" type="text" [formControl]="ridForm.controls.dataSource" required>
        }
        @if(!editing) {
          <select id="dataSource" class="form-control" name="data_source" type="text" (change)="useDataSources($event.target)" required>
            <option disabled selected value></option>
            <option value="x-energy">X-Energy</option>
            <option value="basic">BASIC</option>
            <option value="static">Static</option>
            <option value="eps">EPS</option>
          </select>
        }
      </div>
      @if(rid.data_source == 'static') {
        <div class="form-group">
          <label for="minimum_value">Static minimum value:</label>
          <input id="minimum_value"
                 class="form-control"
                 type="text"
                 [formControl]="ridForm.controls.minimumValue"
                 required="rid.data_source == 'static'"
                 name="minimum_value">
        </div>

        <div class="form-group">
          <label for="maximum_value">Static maximum value:</label>
          <input id="maximum_value"
                 class="form-control"
                 type="text"
                 [formControl]="ridForm.controls.maximumValue"
                 name="maximum_value"
                 required="rid.data_source == 'static'">
        </div>
      }
      <div class="form-group">
        <label for="market_context">Market Context:</label>
        <input name="market_context" id="market_context" class="form-control" type="text" [formControl]="ridForm.controls.market_context" required>
      </div>

      <div class="form-group">
        <label for="resource_id">Resource id:</label>
        <input name="resource_id" id="resource_id" class="form-control" type="text" [formControl]="ridForm.controls.resourceId" required>
      </div>

      <div class="form-group">
        <label for="sample_rate_min">Sample rate min:</label>
        <input name="sample_rate_min" id="sample_rate_min" class="form-control" type="text" [formControl]="ridForm.controls.sampleRateMin" required>
      </div>

      <div class="form-group">
        <label for="sample_rate_max">Sample rate max:</label>
        <input name="sample_rate_max" id="sample_rate_max" class="form-control" type="text" [formControl]="ridForm.controls.sampleRateMax" required>
      </div>

      <div class="form-group">
        <label for="power_type">Power type:</label>
        <select name="power_type" id="power_type" class="form-control" type="select" (change)="usePowerType($event.target)">
          <option disabled selected value></option>
          @for(cp of filteredPowertypes; track cp) {
            <option [value]="cp.uuid" [selected]="editing && cpSelected?.uuid === cp.uuid">
              {{cp.conversion?.description}} -- {{cp.powertype?.itemLabel}}
              ({{cp.powertype?.siScaleCode}}{{cp.powertype?.itemUnit}})
              {{cp.powertype?.hertz}}Hz {{cp.powertype?.voltage}}V
            </option>
          }
        </select>
      </div>
    </div>
    <div class="row">
      <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="!isFormValid()">Save</button>
      <a class="btn" (click)="backPage('/rids', router)">Cancel</a>
    </div>
  </form>
</div>
